// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3E185","title":"BackImages_title__3EtAY","images":"BackImages_images__1o1-i"};